import Axios from 'axios'
import React, { useState, useEffect } from 'react'
import { Modal, Row, Col } from 'react-bootstrap'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import config from '../../config'
import { COLORS, FONTS, SIZES } from '../../styles/theme'
import LoadIcon from '../LoadIcon'

const CustomModal = styled(Modal)`
  .modal-content {
    font-family: ${FONTS.secondary};
    border-radius: 0;
    border: 0;
    box-shadow: 0px 4px 12px ${COLORS.lightGray1};
    padding: 16px;
    text-align: center;
  }
  .modal-header {
    border: none;
    padding: 0 16px;
  }
  .modal-body {
    padding: 0 16px;
    padding-top: 20px;
  }

  .speaker-wrap {
    padding-left: 3rem;
    text-align: start;
  }

  .topic {
    font-weight: bold;
    color: navy;
  }

  .speaker-name {
    font-weight: bold;
    color: navy;
  }
  .speaker-title {
    font-style: italic;
    color: navy;
    padding-bottom: 20px;
  }

  .speaker-topic{
    color: navy;
    padding-bottom: 20px;
  }

  .speaker-img {
    border-radius: 20px;
    margin-bottom: 20px;
  }

  .speaker-prof {
    color: navy;
  }

  .speaker-desc {
    color: navy;
  }

  ${SIZES.mobile} {
    .speaker-wrap {
      padding-left: 0px;
      text-align: center;
    }
  }
`

export default function FacultyMemberModal({ showSpeaker, setShowSpeaker, speakerId }) {
  const [speaker, setSpeaker] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    Axios
      .get(`${config.apiUrl}/api/faculty_members/${speakerId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then(({ status, data }) => {
        if (status === 200 && data.success){
          setSpeaker(data.member)
          setLoading(false)
        }
      })
      .catch((err) => {
        setLoading(false)
        toast("Something went wrong. Please try again later.")
        console.error('Error: ', err)
      })
  }, [])

  return (

    <CustomModal
      size="xl"
      show={showSpeaker}
      onHide={()=>setShowSpeaker(false)}
      aria-labelledby="speaker-modal"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        { speaker ?
          <>
            <Row noGutters>
              <Col sm={12} lg={3} className="align-self-start mt-4 mt-md-0 mobile-hide">
                <img src={speaker.image.url} width="200px" alt="speaker image" className="speaker-img" />
              </Col>
              <Col sm={12} lg={9} className="speaker-wrap">
                <h6 className="speaker-name">{speaker.fullName}</h6>
                {/* <h6 className="speaker-title mb-4">{speaker.title}</h6> */}
                <p className="speaker-desc" dangerouslySetInnerHTML={{ __html: speaker.description }} />
              </Col>
            </Row>
          </>
          :
          <LoadIcon spinnerColor="#ff9e1a" />
        }
      </Modal.Body>
    </CustomModal>
  )
}
